import React, { useEffect, useState } from "react";
import {
  ArrowLeft,
  ProjExelLogo,
  LoginBgImg1,
  LoginBgImg2,
  LoginBgImg3,
} from "../../../assets/images";
import "./LoginCard.scss";
import {
  LoginPayloadType,
  LoginWithMobileNumberPayloadType,
  LoginWithMobileOtpVerifyPayloadType,
} from "../../../commonTypes/authTypes";
import ImageSlider from "./ImageSlider";
import { ViewPassword, HidePassword } from "../../Icon";
import LoginWithMobileNumber from "./LoginWithMobileNumber";
import LoginOtpVerification from "./LoginOtpVerification";
import { Link } from "react-router-dom";
import { Checkbox } from "../../commons";

type LoginTypes = {
  email: string;
  password: string;
};

export type CountryCodeType = {
  value: string;
  label: string;
};

type AppProps = {
  history: any;
  passwordErrorr: string;
  success: number | null;
  error: string | null;
  handleLoginUser: (data: LoginPayloadType) => void;
  handleForgetPassword: (email: string) => void;
  handleMobileOtpVerify: (data: LoginWithMobileOtpVerifyPayloadType) => void;
  handleMobileOtpSend: (data: LoginWithMobileNumberPayloadType) => void;
};

const LoginCard = ({
  history,
  success,
  error,
  passwordErrorr,
  handleLoginUser,
  handleForgetPassword,
  handleMobileOtpVerify,
  handleMobileOtpSend,
}: AppProps) => {
  const [loginData, setLoginData] = useState<LoginTypes>({
    email: "",
    password: "",
  });
  const [inputDetails, setInputDetails] = useState({
    mobileNumber: "",
    otp: "",
  });
  const [countryDialCode, setCountryDialCode] = useState<any>({
    value: "+91",
    label: "🇮🇳 (+91)",
  });
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>(passwordErrorr);
  const [forgetPassword, setForgetPassword] = useState<boolean>(false);
  const [loginWithMobile, setLoginWithMobile] = useState<boolean>(false);
  const [sendOtp, setSendOtp] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(1);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [verifyOtpButton, setVerifyOtpButton] = useState<boolean>(false);
  const [checkBox, setCheckBox] = useState<boolean>(false);
  let redirectToForgetPassword = history.location?.state;
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    if (redirectToForgetPassword === "true") {
      setForgetPassword(true);
    }
  }, []);

  useEffect(() => {
    if (success === 1 && forgetPassword) {
      setDisabled(true);
      setIsActive(true);
    } else if (success === 1 && loginWithMobile) {
      setIsActive(true);
      setMinutes(1);
      setSeconds(0);
      setSendOtp(true);
    } else if (
      success === 0 &&
      error?.includes("Email ID or user does not exist!")
    ) {
      setEmailError("Email ID or user does not exist!");
    } else if (
      success === 0 &&
      error?.includes(
        "Maximum reset password limit exceeded. Please try after 15-minutes"
      )
    ) {
      setMinutes(15);
      setDisabled(true);
      setSeconds(0);
      setIsActive(true);
    } else if (
      success === 0 &&
      error?.includes("Maximum OTP limit reached. Please try after 15-minutes!")
    ) {
      setMinutes(15);
      setSeconds(0);
      setIsActive(true);
      setSendOtp(true);
    }
  }, [success]);

  useEffect(() => {
    if (sendOtp) {
      if (minutes === 0 && seconds === 0) {
        setVerifyOtpButton(true);
        setDisabled(true);
      }
    }
  }, [minutes]);

  const handleInputChange = (event: any) => {
    const Name = event.target.name;
    if (Name === "email") {
      setLoginData((prevState) => ({
        ...prevState,
        email: event.target.value,
      }));

      if (emailError) {
        setEmailError("");
      }
    } else if (Name === "password") {
      setLoginData((prevState) => ({
        ...prevState,
        password: event.target.value,
      }));

      if (passwordError) {
        setPasswordError("");
      }
    }
  };

  const handleFormSubmit = (event: any) => {
    event.preventDefault();
    const { email, password } = loginData;
    if (!forgetPassword) {
      if (email && password) {
        handleLoginUser(loginData);
      } else {
        if (!email) {
          setEmailError("Required");
        }

        if (!password) {
          setPasswordError("Required");
        }
      }
    } else {
      if (email) {
        handleForgetPassword(email);
      } else {
        setEmailError("Required");
      }
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChangeForgetPassword = () => {
    if (forgetPassword) {
      setForgetPassword(false);
    } else {
      setForgetPassword(true);
      setLoginData((prevState) => ({
        ...prevState,
        email: "",
        password: "",
      }));
      setEmailError("");
    }
  };

  const handleResendLink = () => {
    if (loginData?.email) {
      handleForgetPassword(loginData?.email);
      setMinutes(1);
    }
  };

  useEffect(() => {
    let interval: any = null;

    if (isActive && minutes >= 0) {
      interval = setInterval(() => {
        setSeconds(() => seconds - 1);
        if (seconds === 0) {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
        if (minutes === 0 && seconds === 0) {
          setIsActive(false);
          setSeconds(0);
          setMinutes(0);
        }
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  });

  const handleSubmitLoginWithMobile = () => {
    setLoginWithMobile(!loginWithMobile);
  };

  const blank = () => {};

  const handleCheckBox = () => {
    setCheckBox(!checkBox);
  };

  return (
    <div className="container-fluid">
      <div className="row" style={{ height: "100vh" }}>
        <div
          className="col-md-5 back-ground-img hide-left-side"
          style={{ backgroundColor: "#262a44" }}
        >
          <img
            className="position-fixed top-0 start-0"
            style={{ height: "220px" }}
            src={LoginBgImg2}
          />
          <img className="position-fixed top-0 start-0" src={LoginBgImg1} />
          <div className="d-flex justify-content-center align-items-center">
            <ImageSlider />
          </div>
          <div className="company-details position-relative">
            <div className="d-flex flex-column justify-content-center align-items-center">
              <span>Akssai ProjExel Pvt. Ltd.</span>
              <span>
                26 Dixit Enclave, Gorakhpur, Narmada Road, Jabalpur, MP 482004
              </span>
              <span>www.akssai.com | info@akssai.com | +91 7000209293</span>
            </div>
          </div>
        </div>
        <div className="col-md-7 main-login ml-0 login-right">
          <div className="main-login-box">
            {!forgetPassword && !loginWithMobile && (
              <div className="logo-section mb-3">
                <img src={ProjExelLogo} style={{ height: "40px" }} />
                <h5 className="mt-3">Welcome to Finac 👋🏼</h5>
                <span className="description">
                  {" "}
                  We are happy to see you again.You can continue where you left
                  off by logging in.
                </span>
                <div>
                  <div
                    className="form-control error-border mt-3 text-center pointer"
                    style={{ color: "#dd4433" }}
                    onClick={handleSubmitLoginWithMobile}
                  >
                    Login with Mobile Number
                  </div>
                  <div className="d-flex mt-3">
                    <hr className="hr" />
                    <span className="description mt-1">Or</span>
                    <hr className="hr" />
                  </div>
                </div>
              </div>
            )}
            {forgetPassword && (
              <span>
                <Link to="/" className="back-to-login">
                  <img src={ArrowLeft} />
                  Back to Login
                </Link>
                <h5 className="mt-3 mb-3">Forgot Password?</h5>
                <p className="description">
                  Can’t remember your password? Enter your email below to get
                  password reset instructions.
                </p>
              </span>
            )}
            {!loginWithMobile && (
              <form onSubmit={handleFormSubmit}>
                <div className="form-group">
                  <div>
                    <label
                      htmlFor="email"
                      className={loginData.email ? "active" : ""}
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className={`form-control ${
                        !!emailError ? "error-border" : null
                      }`}
                      name="email"
                      value={loginData.email}
                      autoComplete="email"
                      autoFocus
                      onChange={handleInputChange}
                    />
                  </div>
                  {!!emailError && (
                    <small className="input-error">{emailError}</small>
                  )}
                </div>
                {!forgetPassword && (
                  <div className="form-group">
                    <div className="password-position ">
                      <label
                        htmlFor="password"
                        className={loginData.password ? "active" : ""}
                      >
                        Password
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        className={`form-control ${
                          !!passwordError ? "error-border" : null
                        }`}
                        name="password"
                        value={loginData.password}
                        autoComplete="password"
                        onChange={handleInputChange}
                      />
                      {!!passwordError && (
                        <small className="input-error">{passwordError}</small>
                      )}
                      <div className="eye-icon" onClick={toggleShowPassword}>
                        {showPassword ? <ViewPassword /> : <HidePassword />}
                      </div>
                    </div>
                  </div>
                )}
                <div className="d-flex">
                  <span className="mt-1">
                    <Checkbox checked={checkBox} onPress={handleCheckBox} />
                  </span>
                  <span className="ml-2">
                    I agree to the{" "}
                    <a
                      style={{
                        color: "#dd4433",
                        textDecoration: "underline",
                        textUnderlineOffset: "2px",
                      }}
                      href="https://akssai.com/terms-conditions/"
                      target="_blank"
                    >
                      Terms of Service
                    </a>{" "}
                    and{" "}
                    <a
                      style={{
                        color: "#dd4433",
                        textDecoration: "underline",
                        textUnderlineOffset: "2px",
                      }}
                      href="https://akssai.com/privacy-policy/"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                  </span>
                </div>
                <div className="mb-3 mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={disabled || !checkBox}
                  >
                    {forgetPassword ? "Submit" : "Login"}
                  </button>
                </div>
                <div className="form-group text-center">
                  <span
                    className="back-to-login pointer"
                    onClick={handleChangeForgetPassword}
                  >
                    {forgetPassword ? "" : "Forgot Password?"}
                  </span>
                  <p className="resend-link mt-4 mb-0">
                    {forgetPassword ? "Didn't receive link?" : ""}
                  </p>
                  {!isActive && forgetPassword && (
                    <span
                      className={`${
                        disabled ? "back-to-login" : "resend-link"
                      }`}
                      style={{ cursor: disabled ? "pointer" : "not-allowed" }}
                      onClick={disabled ? handleResendLink : blank}
                    >
                      Resend Link
                    </span>
                  )}
                  {isActive && (
                    <span className="resend-link">
                      Resend Link in {minutes <= 9 ? "0" : ""}
                      {minutes}:{seconds <= 9 ? "0" : ""}
                      {seconds}
                    </span>
                  )}
                </div>
              </form>
            )}
            {loginWithMobile && !sendOtp && (
              <LoginWithMobileNumber
                inputDetails={inputDetails}
                setInputDetails={setInputDetails}
                countryDialCode={countryDialCode}
                setCountryDialCode={setCountryDialCode}
                handleMobileOtpSend={handleMobileOtpSend}
              />
            )}
            {sendOtp && (
              <LoginOtpVerification
                inputDetails={inputDetails}
                setInputDetails={setInputDetails}
                setIsActive={setIsActive}
                setVerifyOtpButton={setVerifyOtpButton}
                setSeconds={setSeconds}
                setDisabled={setDisabled}
                handleMobileOtpVerify={handleMobileOtpVerify}
                countryDialCode={countryDialCode}
                verifyOtpButton={verifyOtpButton}
                minutes={minutes}
                seconds={seconds}
                disabled={disabled}
                isActive={isActive}
                handleMobileOtpSend={handleMobileOtpSend}
              />
            )}
            {/* <div className="flex-row">
              <p className="resend-link text-center">
                Don't have an account?{" "}
                <a
                  style={{ color: "#dd4433", cursor: "pointer" }}
                  href="/au-bank-signup"
                  target="_blank"
                >
                  Sign Up
                </a>
                 
              </p>
            </div> */}
            <div>
              <p
                className="copyright"
                style={{
                  color: "#6e7491",
                  fontSize: "12px",
                  textAlign: "center",
                  bottom: "5px",
                }}
              >
                © Copyright {currentYear} | AKSSAI ProjExel | All right reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginCard;
